import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ExportFileAsync } from "../../../../../Backend";
import TableTemplate from "../../../../../Components/Table/TableTemplate";
import { bookNumberMask } from "../../../../../Helpers/utils/utils";
import "./BarcodeOverviewPage.scss";

export function BarcodeOverviewPage() {
  const tableTemplateRef = useRef(null);
  const [t] = useTranslation();

  const [columns] = useState([
    {
      name: "userName",
      headerCaption: t("Name"),
      sortName: "barcode.User.UserName",
      filterName: "barcode.User.UserName",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "barcode",
      headerCaption: t("Barcode"),
      sortName: "barcode.Barcode",
      filterName: "barcode.Barcode",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "bookNumber",
      headerCaption: t("BookNumber"),
      sortName: "book.BookNumber",
      filterName: "book.BookNumber",
      caption: (x) => bookNumberMask(x.bookNumber),
      filterPattern: /^(\d+\.?)+$/,
      filterParser: (x) => x.replace(/\./g, ""),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "isbn",
      headerCaption: t("ISBN"),
      sortName: "book.Isbn",
      filterName: "book.Isbn",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "reportName",
      headerCaption: t("ReportState"),
      sortName: "report.ReportType",
      filterName: "report.ReportType",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "returnDate",
      headerCaption: t("ReturnDate"),
      sortName: "barcode.ReturningBooksEndLimit",
      filterName: "barcode.ReturningBooksEndLimit",
      canSort: true,
      canFilter: true,
      canEdit: false,
      caption: (x) => moment(x.returnDate).format("DD-MM-YYYY"),
    },
  ]);

  const exportBarcodeFile = async () => {
    await ExportFileAsync("Barcodes");
  };

  return (
    <div className="barcode-overview-page">
      <TableTemplate
        ref={tableTemplateRef}
        title={t("BarcodeOverview")}
        endpoint={"/userBooks/all"}
        columns={columns}
        uniqueId="barcode"
        customButtons={[
          {
            name: "Export",
            action: () => exportBarcodeFile(),
            icon: "get_app",
          },
        ]}
        paginator={true}
      />
    </div>
  );
}
